import { render, staticRenderFns } from "./business_detail.vue?vue&type=template&id=106fc302&scoped=true&"
import script from "./business_detail.vue?vue&type=script&lang=js&"
export * from "./business_detail.vue?vue&type=script&lang=js&"
import style0 from "./business_detail.vue?vue&type=style&index=0&id=106fc302&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106fc302",
  null
  
)

export default component.exports